import { useState } from "react";
import { HandleApiError } from "../../components/Notifications/APIErrorHandler";
import {
    getMedicalCenters,
    getMedicalCenter,
    createMedicalCenter,
    editMedicalCenter,
    removeMedicalCenter,
} from "../../api/medicalCenter";

export const useMedicalCenters = (tenantId = null) => {
    const [medicalCenters, setMedicalCenters] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getAll = () => {
        setIsLoading(true);
        getMedicalCenters(tenantId)
            .then(response => {
                setMedicalCenters(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                HandleApiError(error);
                setIsLoading(false);
            });
    };

    const get = async (id, isSubscribed) => {
        try {
            setIsLoading(true);
            const resp = await getMedicalCenter(id, tenantId);
            if (isSubscribed) {
                setIsLoading(false);
                return resp.data;
            }
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);
            return {};
        }
    };

    const create = (data) => createMedicalCenter(data, tenantId);

    const update = (id, data) => editMedicalCenter(id, data, tenantId);

    const remove = (id) => removeMedicalCenter(id, tenantId);

    return [medicalCenters, isLoading, getAll, get, create, update, remove];
};
